module.exports = __webpack_public_path__ + "img/contact-linz-3.e827344.jpg?v=1761300065174";